import BaseWinnersViewComponent from '@/components/game-winners/_components/base';
import HamsterRaceWinnersViewComponent from '@/components/game-winners/_components/hamster-race';
import QuizQuidsViewComponent from '@/components/game-winners/_components/quiz-quids';
import GameWinnersWinnersViewComponent from '@/components/game-winners/_components/game-winners';
import CincoWinnersWinnersViewComponent from '@/components/game-winners/_components/cinco-winners';
import ArcadeWinnersComponent from '@/components/game-winners/_components/arcade';
import PictureBingoWinnersComponent from '@/components/game-winners/_components/picture-bingo';
import ReelBingoWinnersComponent from '@/components/game-winners/_components/reel-bingo';
export default {
  baseWinnersView: BaseWinnersViewComponent,
  hamsterRaceWinnersView: HamsterRaceWinnersViewComponent,
  quizQuidsWinnersView: QuizQuidsViewComponent,
  gameWinnersWinnersView: GameWinnersWinnersViewComponent,
  cincoWinnersView: CincoWinnersWinnersViewComponent,
  arcadeWinnersView: ArcadeWinnersComponent,
  pictureBingoWinnersView: PictureBingoWinnersComponent,
  reelBingoWinnersView: ReelBingoWinnersComponent
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game-winners/_components/index.ts